import React, { useState, useEffect, useContext } from 'react';
import {
  FormInput,
  Widget,
  usePromise,
  CrudContext,
  FormSubmitButton,
  FormatText,
  FormSelect,
  FormNumber,
  MasterDetailForm,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { getAllTipoDocumentoCobrancaByMedicaoOptions } from '@app/api/contrato/planilhaQuantidadeContrato';
import { getEstabelecimentosOptions } from '@app/api/estabelecimento';
import {
  createAutorizacao,
  getSituacaoProcessoInfo,
  SituacaoProcessoInfo,
} from '@app/api/autorizacaoPagamento/autorizacao';
import AutorizacaoContainer from './autorizacaoContainer';
import { hasPermission } from '@app/helpers/permissions';
import { currencyFormat } from '@app/helpers/numbers';
import CurrencyInput from '@app/components/CurrencyInput';
import { useRecoilValue } from 'recoil';
import { medicaoSelectedState } from '../atoms';

export interface PropsAbaAutorizacaoPagamento {
  usuarioLogadoFinanceiroDoContratoFornecedor: boolean;
}

const AutorizacaoPagamento = (props: PropsAbaAutorizacaoPagamento) => {
  const { usuarioLogadoFinanceiroDoContratoFornecedor } = props;
  const { Panel } = Collapse;
  const medicaoSelected = useRecoilValue(medicaoSelectedState);
  const [situacaoData, setSituacaoData] = useState();
  const [initialForm, setInitialForm] = useState();

  const [initialValue] = usePromise(
    () => {
      return medicaoSelected ? getSituacaoProcessoInfo(medicaoSelected.id) : Promise.resolve(undefined);
    },
    [medicaoSelected],
    {} as SituacaoProcessoInfo,
  );

  useEffect(() => {
    setSituacaoData(initialValue);
  }, [initialValue]);

  useEffect(() => {
    setInitialForm(initialForm);
  }, [initialForm]);

  const updatePage = () => {
    getSituacaoProcessoInfo(medicaoSelected.id).then(resp => setSituacaoData(resp));
  };

  const handleCadastrarAutorizacao = (values: any) => {
    createAutorizacao(medicaoSelected.id, values).then(resp => {
      if (resp) {
        updatePage();
        setInitialForm(true);
        setInitialForm(null);
      }
    });
  };

  return (
    <>
      {medicaoSelected && medicaoSelected.aprovacaoEPagamentoAutomatica == false ? (
        <MasterDetailForm initialValues={initialForm} onSubmit={handleCadastrarAutorizacao}>
          <Widget
            title="Cadastrar Autorização"
            actions={[
              <>
                {hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_CADASTRAR']) && (
                  <FormSubmitButton
                    noIcon={true}
                    type="success"
                    disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_CADASTRAR'])}>
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                )}
              </>,
            ]}>
            <FormSelect
              label="Tipo de Documento de Cobrança"
              name="tipoDocumentoCobrancaId"
              getOptions={getAllTipoDocumentoCobrancaByMedicaoOptions(medicaoSelected.id)}
              span={4}
              required
            />
            <FormSelect
              label="Estabelecimento"
              name="estabelecimentoId"
              getOptions={getEstabelecimentosOptions}
              span={4}
              required
            />
            <CurrencyInput defaultValue={0} label="Valor" name="valor" span={3} />
          </Widget>
        </MasterDetailForm>
      ) : (
        <></>
      )}
      <MasterDetailForm initialValues={situacaoData}>
        <Widget title="Situação do Processo">
          <FormInput label="Status" name="status" span={3} disabled />
          <FormNumber formatter={currencyFormat} label="Valor da Medição" name="valorMedicao" span={3} disabled />
          <FormNumber formatter={currencyFormat} label="Valor do Pênalti" name="valorPenalti" span={3} disabled />
          <FormNumber
            formatter={currencyFormat}
            label="(Valor da Medição - Valor do Pênalti)"
            name="valorMedicaoMenosValorPenalti"
            span={3}
            disabled
          />
          <FormNumber formatter={currencyFormat} label="Valor Autorizado" name="valorAutorizado" span={3} disabled />
          <FormNumber formatter={currencyFormat} label="Valor Pago" name="valorPago" span={3} disabled />
        </Widget>
      </MasterDetailForm>

      {situacaoData &&
        situacaoData.autorizacoesId &&
        situacaoData.autorizacoesId.map(item => (
          <AutorizacaoContainer
            aprovacaoEPagamentoAutomatica={medicaoSelected.aprovacaoEPagamentoAutomatica}
            usuarioLogadoFinanceiroDoContratoFornecedor={usuarioLogadoFinanceiroDoContratoFornecedor}
            onUpdate={updatePage}
            autorizacaoId={item}
            key={item}
          />
        ))}
    </>
  );
};

export default AutorizacaoPagamento;
